export const DOCUMENT_NAMES_TO_REMOVE = [
    'Calculos',
    'Score'
];

export const ENRICHMENT_RULES_TO_REMOVE = [
    'OD051',
    'OD052',
    'OD053'
];
